import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              最新发布
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              发现更多新鲜有趣的创作内容
            </p>
          </div>
          <Link
            to="/category/illustration"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700">
                  {article.categoryName}
                </span>
                <h3 className="mt-3 font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 mt-4 text-xs text-foreground-500">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-8 sm:hidden">
          <Link
            to="/category/illustration"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}